import { render } from "./medicalIcons.vue?vue&type=template&id=757bb85b&scoped=true"
import script from "./medicalIcons.vue?vue&type=script&lang=js"
export * from "./medicalIcons.vue?vue&type=script&lang=js"

import "./medicalIcons.vue?vue&type=style&index=0&id=757bb85b&lang=scss&scoped=true"

import exportComponent from "/home/webiotcpc/dhruvi/Git/tivo/vue-tivo/tivo-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-757bb85b"]])

export default __exports__